import { render, staticRenderFns } from "./ConfigMwx.vue?vue&type=template&id=66f8b45e"
import script from "./ConfigMwx.vue?vue&type=script&lang=js"
export * from "./ConfigMwx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports